import { Link } from 'react-router-dom';
import { businessConfig } from '../../config/business';

export default function Footer() {
  return (
    <footer className="bg-[#0f2942] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="relative w-10 h-10 flex items-center justify-center">
                <div className="absolute inset-0 bg-gradient-to-br from-[#2563eb] to-[#3b82f6] rounded-lg transform rotate-45"></div>
                <i className="ri-water-flash-line text-xl relative z-10 transform -rotate-45 text-white"></i>
              </div>
              <span className="text-xl font-['Crimson_Pro'] font-bold">{businessConfig.name.replace(' LLC', '')}</span>
            </div>
            <p className="text-white/80 leading-relaxed mb-4 text-sm">
              Professional pool cleaning, maintenance, and repair services serving {businessConfig.serviceArea.full}.
            </p>
            <div className="flex items-center space-x-2 text-sm">
              <i className="ri-shield-check-line text-[#2563eb]"></i>
              <span className="text-white/90">Licensed & Insured</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-[#2563eb] transition-colors duration-300 text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/residential" className="text-white/80 hover:text-[#2563eb] transition-colors duration-300 text-sm">
                  Residential Service
                </Link>
              </li>
              <li>
                <Link to="/commercial" className="text-white/80 hover:text-[#2563eb] transition-colors duration-300 text-sm">
                  Commercial / HOA
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-[#2563eb] transition-colors duration-300 text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/services/repairs" className="text-white/80 hover:text-[#2563eb] transition-colors duration-300 text-sm">
                  Repairs
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-[#2563eb] transition-colors duration-300 text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Service Hours */}
          <div>
            <h4 className="text-lg font-bold mb-4">Service Hours</h4>
            <div className="space-y-2 text-white/80 text-sm">
              <div className="flex items-center space-x-2">
                <i className="ri-time-line text-[#2563eb]"></i>
                <p className="font-semibold text-white">{businessConfig.hours}</p>
              </div>
              <p>Available 7 Days a Week</p>
              <p className="text-white/60 mt-4">Emergency service available anytime</p>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <a 
                href={`tel:${businessConfig.phone.primaryRaw}`}
                className="flex items-center space-x-3 text-white/80 hover:text-[#2563eb] transition-colors duration-300 group cursor-pointer"
              >
                <i className="ri-phone-line text-xl group-hover:scale-110 transition-transform duration-300"></i>
                <span className="text-sm">{businessConfig.phone.primary}</span>
              </a>
              <a 
                href={`tel:${businessConfig.phone.secondaryRaw}`}
                className="flex items-center space-x-3 text-white/80 hover:text-[#2563eb] transition-colors duration-300 group cursor-pointer"
              >
                <i className="ri-phone-line text-xl group-hover:scale-110 transition-transform duration-300"></i>
                <span className="text-sm">{businessConfig.phone.secondary}</span>
              </a>
              <a 
                href={`mailto:${businessConfig.email}`}
                className="flex items-center space-x-3 text-white/80 hover:text-[#2563eb] transition-colors duration-300 group cursor-pointer"
              >
                <i className="ri-mail-line text-xl group-hover:scale-110 transition-transform duration-300"></i>
                <span className="text-sm">{businessConfig.email}</span>
              </a>
              <div className="flex items-start space-x-3 text-white/80">
                <i className="ri-map-pin-line text-xl mt-1"></i>
                <span className="text-sm">{businessConfig.serviceArea.full}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="text-white/60 text-sm">
            © {new Date().getFullYear()} {businessConfig.name}. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="nofollow noopener noreferrer"
            className="text-white/60 hover:text-[#2563eb] text-sm transition-colors duration-300"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
